module.exports = __webpack_public_path__ + "img/gr-h2.a06c3abe.png";